module.exports = __webpack_public_path__ + "static/media/CheckmarkCircleFilled.35b46504.svg";